import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { wheelAnim } from '../animation/wheelText';

gsap.registerPlugin(ScrollTrigger, SplitText, DrawSVGPlugin);

export default class CircuitsAnim {
  constructor(section) {
    this.section = section;
		this.title = this.section.querySelector(".section-title");
		this.boxes = [...this.section.querySelectorAll(".boxes")];

    this.init();
  }

  init() {
		document.fonts.ready.then(() => {
			this.titleSplit = SplitText.create(this.title, {type: "lines", autoSplit: true, mask: "lines", aria: "none" });

			this.tl = gsap.timeline({
				scrollTrigger: {
					trigger: this.section,
					start: "top 70%",
					once: true,
				},
				onComplete: () => {
					this.titleSplit.revert();
				}
			});

			this.tl
				.set([this.title], {autoAlpha: 1}, 0)
				.from(this.titleSplit.lines, { yPercent: 50, autoAlpha: 0, duration: 2, ease: "expo.out"}, 0)

			this.boxes.forEach(box => {
				const svg = [...box.querySelectorAll("svg path")];
				const caption = box.querySelector(".intro");
				const dates = box.querySelector(".dates");	

				this.tl
					.to(caption, {autoAlpha: 1, duration: 1}, 0.3)
					.to(dates, {autoAlpha: 1, duration: 1}, 0.4)
					.call(() => wheelAnim(dates), null, 0.4)
					.set(svg, { drawSVG: "0%" }, 0)
					.to(svg, {
					drawSVG: "100%",
					duration: 3,
					stagger: -0.1,
					ease: "power4.inOut",
				}, 0.1);
			});
		});
  }
}